<template>
    <div class="pay">
 
        <van-nav-bar title="消息记录" left-text="返回" left-arrow @click-left="$router.push('/my')" />
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              v-if="list"
            >
              <c-card class="pay-row c-margin-top-normal" v-for="(item, index) in list" :key="index">
                <template >
                  <p class="pay-row-item">
                    <label class="pay-row-item__title">消息内容：</label>
                    {{ item.Msgcontent }}
                  </p>
                  <p class="pay-row-item">
                    <label class="pay-row-item__title">发送时间：</label>
                    {{ item.Createtime }}
                  </p>
                
                </template>
              </c-card>
            </van-list>
          </van-pull-refresh>
        
    </div>
  </template>
  
  <script>
  import { NavBar, Tabs, Tab, PullRefresh, List, Toast } from 'vant'
  import CCard from '@/components/c-card.vue'
  
  export default {
    data() {
      return {
        payType: {
          0: '支付宝',
          1: '微信',
          2: '其他',
        },
        refreshing: false,
        pageNo: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        finished: false,
        studentInfo:{},
        list: [],
        money: ''
      }
    },
    mounted(){
      var sinfo = localStorage.getItem("currentChild");
          this.studentInfo = JSON.parse(sinfo);
          if(this.studentInfo.Studentid==""){
            Toast("未选定孩子")
            this.$router.push("/my");
            return;
          }
    },
    methods: {
      onRefresh() {
        // 清空列表数据
        this.finished = false
        this.pageNo = 1
        this.list = []
  
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.refreshing = true
        this.onLoad()
      },
  
      onLoad() {
        this.getList()
        this.pageNo++
      },
      // 获取充值记录列表
      getList() {
        var api = this.$api.studentcard.getdevicesendmsglist
        this.$http
        .json_post(api, {
            Studentid: eval(this.studentInfo.Studentid),
            Pageindex: this.pageNo,
            Pagesize: this.pageSize
        })
        .then((data) => {
            if (data.code == 0) {
            const res = data.data
            
            if (res.length === 0) {
                //this.list = []
                this.loading = false
            this.refreshing = false
                this.finished = true
                return
            }
            this.list.push(...res)
            this.loading = false
            this.refreshing = false
            
            }else{
            Toast(data.msg)
            }
        })
        
      },
      beforeChange(index) {
        this.tabActive = index
        this.pageNo = 1
        this.list = []
        this.onLoad()
        return true
      },
    },
    components: {
      'van-list': List,
      'van-pull-refresh': PullRefresh,
      'van-nav-bar': NavBar,
      'van-tabs': Tabs,
      'van-tab': Tab,
      'c-card': CCard,
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .pay-row-item {
    line-height: 20px;
    .pay-row-item__title {
      display: inline-block;
      width: 75px;
      color: $text-secondary-color;
    }
  }
  </style>
  